export enum ServerResponse {
    notSupported = -1,
    success = 200,
    badRequest = 400,
    internalServerError = 500,
}
